/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 outfit6.glb 
*/

import React from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/outfit6.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				geometry={nodes.hair001.geometry}
				material={materials["hair_defaultMat4.004"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.hair001_1.geometry}
				material={materials["Dummy_SHD1.004"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.oufit9_1.geometry}
				material={materials["Soft Suede Fabric.004"]}
				position={[0, -0.246, 0.329]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.oufit9_2.geometry}
				material={materials["White Satin Fabric.004"]}
				position={[0, -0.246, 0.329]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.oufit9_4.geometry}
				material={materials["Soft Brown Satin Fabric.004"]}
				position={[0, -0.246, 0.329]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.oufit9_6.geometry}
				material={materials["Leather.004"]}
				position={[0, -0.246, 0.329]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.oufit9_8.geometry}
				material={materials["Brown leather.004"]}
				position={[0, -0.246, 0.329]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.oufit9_9.geometry}
				material={materials["Elastane Varnished.001"]}
				position={[0, -0.246, 0.329]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.oufit9_11.geometry}
				material={materials["Black Rose.001"]}
				position={[0, -0.246, 0.329]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.oufit9_12.geometry}
				material={materials["Satin Fabric.005"]}
				position={[0, -0.246, 0.329]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.oufit9_13.geometry}
				material={materials["Clean silver(Shiny Metal).004"]}
				position={[0, -0.246, 0.329]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.Retopo_body002.geometry}
				material={materials["Neutral Woven Fabric.004"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.Retopo_shoes_r003.geometry}
				material={materials["Material.004"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
		</group>
	);
}

useGLTF.preload("models/outfit6.glb");
